import * as types from './actionTypes';

export const uploadVideo = (fileName, videoId, thumbnailId, transcription, type, videoBlob) => ({
	type: types.UPLOAD_VIDEO,
	payload: { fileName, videoId, thumbnailId, transcription, type, videoBlob },
});

export const progressVideo = (progressStatus) => ({
	type: types.VIDEO_PROGRESS,
	payload: { progressStatus },
});

export const resetUploadVideo = () => ({
	type: types.RESET_UPLOAD_VIDEO

});

export const resetProgressStatus = () => ({
	type: types.RESET_PROGRESS_STATUS

});

export const uploadAudioRec = (audioFileName, audioId, thumbnailId, transcription, type, audioBlob, audioDetails) => ({
	type: types.UPLOAD_AUDIO,
	payload: { audioFileName, audioId, thumbnailId, transcription, type, audioBlob, audioDetails },
});

export const progressAudio = (progressStatusAudio) => ({
	type: types.AUDIO_PROGRESS,
	payload: { progressStatusAudio },
});

export const resetUploadAudio = () => ({
	type: types.RESET_UPLOAD_AUDIO

});

export const resetProgressStatusAudio = () => ({
	type: types.RESET_PROGRESS_STATUS_AUDIO

});

export const searchFilterData = (search) => ({
	type: types.SEARCH_FILTER_DATA,
	payload: { search }

});

export const resetSearchFilterData = () => ({
	type: types.RESET_SEARCH_FILTER_DATA,


});

export const updateBookmarkAction = () => ({
	type: types.UPDATE_BOOKMARK,
});

export const configSet = () => ({
	type: types.CONFIG_SET,
});

//add user data
export const addUserData = (payload) => {
	return {
		type: "ADD_USER",
		payload: payload,
	};
};

//delete user data
export const deleteUserData = () => {
	return {
		type: "DELETE_USER",
	};
};


